module.exports = __webpack_public_path__ + "img/law.05b226f4.png";